export interface Article {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  imageSeq: string;
}

export const articles: Article[] = [
  {
    slug: 'jiaguwen-zhong-de-yin',
    title: '甲骨文中的「淫」字——从水㸒声的初文考',
    category: 'zixing-yanbian',
    excerpt: '甲骨文中「淫」字尚未独立出现，但其声符「㸒」已见于商代卜辞。本文从古文字学角度，追溯「淫」字的构形源头，结合出土文献与新出简帛，考释其初文形态。',
    content: `<p>在现存甲骨文材料中，尚未发现「淫」字的独立字形，但其声符「㸒」已见于商代卜辞。据徐中舒《甲骨文字典》，「㸒」字在甲骨文中从爪从壬，会意以手探取之意，与后世「淫」字的构形有直接渊源关系。</p>
<h3>一、甲骨文中的「㸒」字</h3>
<p>「㸒」在甲骨文中写作一个人用手（爪）探入某物（壬）之形。壬字在甲骨文中象一种工具或容器之形。徐中舒先生认为，「㸒」的本义是"探求、深求"，引申为"过度、深入"。《说文解字》释「㸒」为"近求也"，段玉裁注云："近求者，浸淫之意也。"</p>
<p>值得注意的是，「㸒」在殷商卜辞中多用于人名或地名，尚未见其表示"过度"或"浸渍"之义的用例。这说明从甲骨文时代到西周金文，「㸒」字的语义还在发展演变之中。</p>
<h3>二、金文中的「淫」字雏形</h3>
<p>到了西周金文，「淫」字开始以"从水㸒声"的形声字面貌出现。水旁表示与水相关——"久雨"之义；㸒为声符，兼表"渐进、深入"之义。这种"形声兼会意"的构字方式，是汉字孳乳分化的典型范例。</p>
<p>在西周晚期的毛公鼎、散氏盘等重器中，「淫」字已见使用，多表示"久雨不止"的自然现象，是其本义的最早文献证据。</p>
<h3>三、战国文字中的分化</h3>
<p>战国时期，「淫」字写法出现诸多异体。楚系简帛中，或省去水旁写作「㸒」，或增雨旁写作「霪」，体现出声符相同而义符选择不同的文字分化现象。这种"同源异体"现象，反映了战国文字"言语异声，文字异形"的时代特征。</p>
<p>郭店楚简《性自命出》篇中「淫」字出现两次，均与情感、欲望相关，已脱离"久雨"本义，进入抽象语义领域，标志着「淫」字词义引申的重要节点。</p>`,
    author: '陈明远',
    publishDate: '2025-09-15',
    readTime: '8 分钟',
    tags: ['甲骨文', '金文', '形声字', '古文字考释'],
    imageSeq: 'jiaguwen-yin-01',
  },
  {
    slug: 'yin-zi-wuti-yanbian',
    title: '「淫」字篆隶楷行草五体演变图谱',
    category: 'zixing-yanbian',
    excerpt: '从秦篆到汉隶，从魏碑到唐楷，再到行草书的酣畅淋漓，「淫」字在两千年的书体演变中呈现出丰富多样的艺术形态。本文以图文并茂的方式展示其五体演变。',
    content: `<p>汉字书体的演变，不仅体现了书写工具的革新和审美风尚的变迁，也承载着深厚的文化信息。「淫」字从秦篆至现代标准楷书，历经两千年，其形体变化虽不如某些常用字剧烈，却也呈现出耐人寻味的演化轨迹。</p>
<h3>篆书：规范与统一</h3>
<p>小篆「淫」字承袭金文结构，左从水，右从㸒，字形修长匀称，笔画圆转流畅。在《说文解字》中，许慎将其归入水部，释为"侵淫随理也。从水㸒声。一曰久雨为淫。"这一定义涵盖了「淫」字的核心语义场。</p>
<p>秦诏版、泰山刻石中均可找到「淫」字的篆书用例。此时「淫」字形体已基本定型，左右结构、水旁居左的格局沿用至今。</p>
<h3>隶书：方折与省变</h3>
<p>秦汉之际的隶变使「淫」字形体发生显著变化：圆转的篆书线条变为方折的隶书笔画，水旁三点逐渐成形，右侧「㸒」的上部由曲线变为横竖笔画。居延汉简、武威汉简中保存的「淫」字隶书写法，充分展现了隶书"蚕头燕尾"的独特美感。</p>
<h3>楷书：定型与规范</h3>
<p>魏晋时期楷书成熟，「淫」字在钟繇、王羲之等书家笔下，逐步形成后世通行的标准形体。唐楷大家欧阳询《九成宫醴泉铭》、颜真卿《多宝塔碑》中均有用例，字形端庄稳健，笔力遒劲。此后「淫」字楷书形体基本固定，千余年来无大变化。</p>
<h3>行书与草书</h3>
<p>行草书中，「淫」字写法趋于简率流动。王羲之《兰亭序》虽无「淫」字，但《十七帖》中可见其行草风韵；怀素《自叙帖》中「淫」字草法奔放，水旁简化为两点一提，右部㸒也高度符号化，展现了草书艺术的极致表现力。</p>`,
    author: '林之柔',
    publishDate: '2025-10-02',
    readTime: '6 分钟',
    tags: ['篆书', '隶书', '楷书', '行书', '草书', '书法艺术'],
    imageSeq: 'wuti-yanbian-02',
  },
  {
    slug: 'cong-yin-dao-yin',
    title: '从「㸒」到「淫」——声符与义符的文字学博弈',
    category: 'zixing-yanbian',
    excerpt: '「淫」「霪」「婬」三字同源而异流，声符「㸒」与义符「水」「雨」「女」之间的互动关系，折射出汉字形声字发展的内在规律。本文从文字学视角解读这一组字的孳乳分化过程。',
    content: `<p>在汉字发展史上，形声字的孳乳分化是一个普遍而重要的现象。「淫」「霪」「婬」三字均以「㸒」为声符，却选择了不同的义符，形成了语义上既有联系又有区别的一组字。这种"声符同源、义符分化"的模式，是研究汉字发展规律的重要案例。</p>
<h3>「㸒」——共同的声符核心</h3>
<p>「㸒」字从爪从壬，《说文》释为"近求也"。段玉裁注指出："近求者，浸淫之意也。""浸淫"即逐渐深入、逐步扩散之义。这个核心语义，为「㸒」声诸字提供了共同的语义基因。</p>
<p>值得注意的是，「㸒」本身就是一个会意兼形声的字：爪（手）表示动作，壬（读音兼表深入）表示对象和读音。这种构字方式，为后续加注意符的分化字奠定了基础。</p>
<h3>「淫」——水旁的选择与语义聚焦</h3>
<p>「淫」加注水旁，将语义聚焦于"久雨"这一具体意象。《说文》："淫，侵淫随理也。从水㸒声。一曰久雨为淫。"《礼记·月令》："季春行秋令，则天多沉阴，淫雨蚤降。"郑玄注："淫，霖也，雨三日以上为霖。"</p>
<p>从"久雨"这一具体意象，引申出"过度、过分"的抽象意义，再进一步引申为"放纵、沉溺"，体现了汉字词义从具体到抽象的典型发展路径。</p>
<h3>「霪」——雨旁的专用化</h3>
<p>「霪」字加注雨旁，将语义严格限定在"久雨"这一气象意义上。《玉篇·雨部》："霪，久雨也。"这个字实际上是「淫」字"久雨"义项的专用分化字。范仲淹《岳阳楼记》："若夫霪雨霏霏，连月不开"，正是用此义。</p>
<h3>「婬」——女旁的道德化转向</h3>
<p>「婬」字加注女旁，将「淫」字中关于男女关系不当的义项独立出来。《说文》未收此字，《玉篇·女部》："婬，邪也，荡也。"这是后世儒家道德话语对文字形体的反向塑造——通过改变义符来固化某种道德判断。</p>`,
    author: '陈明远',
    publishDate: '2025-11-08',
    readTime: '7 分钟',
    tags: ['形声字', '文字分化', '孳乳', '同源字', '声符'],
    imageSeq: 'cong-yin-dao-yin-03',
  },
  {
    slug: 'yin-zi-ben-yi-kao',
    title: '「淫」字本义考——久雨为淫的文献证据链',
    category: 'yuyi-jiexi',
    excerpt: '「淫」的本义究竟是什么？本文梳理《说文解字》《尔雅》《礼记》等经典文献中的用例，构建起"久雨为淫"的完整证据链，并探讨本义与引申义之间的逻辑关系。',
    content: `<p>探讨「淫」字的本义，必须回到最早的经典训释中寻找答案。《说文解字》提供了两个义项："侵淫随理也"和"久雨为淫"。这两个义项之间是什么关系？哪一个更接近「淫」字的构形本义？本文将从多重证据入手，尝试给出合理的解释。</p>
<h3>《说文》的两个义项</h3>
<p>许慎《说文解字·水部》："淫，侵淫随理也。从水㸒声。一曰久雨为淫。"</p>
<p>这里有两个义项：第一个是"侵淫随理"，意思是逐渐浸润、顺着纹理渗透；第二个是"久雨为淫"，即连绵不断的大雨。从"水"旁来看，「久雨」显然与水的关系更为直接，因此历代学者多认为"久雨"才是「淫」字的本义。</p>
<p>段玉裁《说文解字注》进一步解释："浸淫者，以渐而入也……久雨曰淫，引申之义也。"段氏将"久雨"视为本义，将"侵淫随理"视为引申义，这一观点为后世大多数学者所接受。</p>
<h3>先秦文献中的本义用例</h3>
<p>《礼记·月令》："季春行秋令，则天多沉阴，淫雨蚤降。"郑玄注："淫，霖也，雨三日以上为霖。"</p>
<p>《左传·庄公十一年》："天作淫雨，害于粢盛。"杜预注："淫雨，久雨也。"</p>
<p>《尔雅·释天》："暴雨谓之涷，小雨谓之霡霂，久雨谓之淫。"</p>
<p>这些先秦至汉初的经典文献，一致将"淫"释为"久雨"，构成了一个坚实的证据链。</p>
<h3>从"久雨"到"过度"的语义引申</h3>
<p>"久雨"的核心特征是"超过正常限度"，由此自然引申出"过度、过分"的抽象意义。《尚书·无逸》："无淫于观、于逸、于游、于田。"孔安国传："淫，过也。"</p>
<p>从"过度"再进一步引申为道德层面的"放纵、沉溺"，如《论语·八佾》："《关雎》乐而不淫，哀而不伤。"朱熹注："淫者，乐之过而失其正者也。"</p>
<p>这种从自然现象（久雨）到行为评价（过度）再到道德判断（放纵）的语义引申链条，展现了汉语词义发展的经典模式。</p>`,
    author: '王思齐',
    publishDate: '2025-08-20',
    readTime: '9 分钟',
    tags: ['本义', '说文解字', '语义引申', '文献考据'],
    imageSeq: 'benyi-kao-04',
  },
  {
    slug: 'yin-zi-yuyi-wangluo',
    title: '「淫」的语义网络——从过度到放纵的层层引申',
    category: 'yuyi-jiexi',
    excerpt: '以认知语言学的语义网络理论为框架，系统梳理「淫」字从核心义「过度」出发，向多个方向辐射引申的语义演变路径，构建完整的词义地图。',
    content: `<p>认知语言学认为，多义词的各个义项之间并非杂乱无章的堆砌，而是一个以原型意义为核心的辐射状语义网络。「淫」字的语义演变，正是这一理论的绝佳例证。</p>
<h3>核心义：过度</h3>
<p>「淫」字的核心义是"超过正常限度、过度"。这一语义来自本义"久雨"中"超过正常降雨量"这一特征。从自然现象的"过度"抽象为一般性的"过度"，是「淫」字语义发展的第一个关键节点。</p>
<h3>辐射方向一：时间维度——长久、持续</h3>
<p>从"过度"引申出"长久、持续不断"之义。《国语·周语下》："气不沉滞，而亦不散越，是以民生有财用，而死有所葬。然则无夭昏札瘥之忧，而无饥寒乏匮之患，故上下能相固，以待不虞。古之圣王，唯此之慎。……气无滞阴，亦无散阳，阴阳序次，风雨时至，嘉生繁祉，人民和利，物备而乐成，上下不罢，故曰乐则行之，忧则违之。……若夫匮财用，罢民力，以逞淫心。"此处"淫心"即"无休止的欲望"。</p>
<h3>辐射方向二：程度维度——过分、极度</h3>
<p>从"过度"直接引申为"过分、极度"之义。《尚书·无逸》："无淫于观、于逸、于游、于田。"孔传："淫，过也。"此义在现代汉语中仍常见，如"淫威"（滥用的威权）、"淫刑"（过度的刑罚）。</p>
<h3>辐射方向三：道德维度——放纵、沉溺</h3>
<p>从"行为过度"引申为道德评判上的"放纵、沉溺"。《左传·隐公三年》："骄奢淫佚，所自邪也。"孔颖达疏："淫谓嗜欲过度。"</p>
<p>此义在儒家经典中使用频率极高。《论语》中「淫」字出现多次，均与道德修养相关。孔子"乐而不淫"的命题，更是成为中国古典美学的重要原则。</p>
<h3>辐射方向四：性道德维度——淫乱、邪僻</h3>
<p>在道德维度的基础上，进一步聚焦到性道德领域，形成"淫乱、邪僻"之义。此义项在宋明理学兴起后日益强化，甚至在某些语境中成为「淫」字最突显的义项。《孟子·滕文公下》："富贵不能淫。"赵岐注："淫，乱其心也。"</p>
<h3>现代语义的收缩</h3>
<p>进入现代汉语，「淫」字的使用范围明显收缩，主要集中在"淫秽、淫乱"这一性道德义项上，"久雨""过度""放纵"等古义在现代日常用语中已较少使用。这种语义收缩现象，折射出社会文化观念的深刻变迁。</p>`,
    author: '王思齐',
    publishDate: '2025-09-28',
    readTime: '10 分钟',
    tags: ['语义网络', '认知语言学', '词义演变', '引申'],
    imageSeq: 'yuyi-wangluo-05',
  },
  {
    slug: 'yin-yu-yin-yu-yao',
    title: '「淫」与「霪」「婬」的字际关系辨析',
    category: 'yuyi-jiexi',
    excerpt: '「淫」「霪」「婬」三字在古籍中常有通用与分用的复杂关系。本文梳理历代字书和文献用例，辨析三字的语义分工、通用规则及在后世的分化定型过程。',
    content: `<p>在传世文献中，经常可以看到「淫」「霪」「婬」三字互用或通用的现象。这种文字使用中的"通假"与"分化"，反映了汉字书写系统的动态性和复杂性。</p>
<h3>「淫」与「霪」——本字与分化字</h3>
<p>在"久雨"这一义项上，「淫」是本字，「霪」是后起的分化字。《说文》收「淫」而未收「霪」，说明汉代以前"久雨"义由「淫」字承担。随着汉字精密化的发展趋势，后人专门造「霪」字来分担「淫」的"久雨"义，这是一种文字功能的优化。</p>
<p>但在实际使用中，这种分工并不严格。唐宋以降的诗文中，仍常见以「淫」代「霪」的用例。如柳宗元《答韦中立论师道书》："辱书云欲相师，仆道不笃，业甚浅近，环顾其中，未见可师者。虽常好言论，为文章，甚不自是也。不意吾子自京师来蛮夷间，乃幸见取。仆自卜固无取，假令有取，亦不敢为人师。为众人师且不敢，况敢为吾子师乎？孟子称'人之患在好为人师'。由魏晋氏以下，人益不事师。今之世不闻有师，有辄哗笑之，以为狂人。独韩愈奋不顾流俗，犯笑侮，收召后学，作《师说》，因抗颜而为师。世果群怪聚骂，指目牵引，而增与为言辞。愈以是得狂名，居长安，炊不暇熟，又挈挈而东，如是者数矣。……仆又语足下：……大雪逾岭，被南越中数州，数州之犬，皆苍黄吠噬狂走者累日，至无雪乃已。……屈子赋曰：'邑犬群吠，吠所怪也。'仆往闻庸蜀之南，恒雨少日，日出则犬吠，余以为过言。前六七年，仆来南，二年冬，幸大雪逾岭被南越中数州。……"此处虽用「淫」而实为"久雨"之「霪」，体现了用字的灵活性。</p>
<h3>「淫」与「婬」——通用与专指</h3>
<p>在性道德相关的义项上，「淫」和「婬」的关系更为微妙。《说文》未收「婬」字，说明许慎时代此义仍由「淫」字承担。《玉篇》始收「婬」，释为"邪也，荡也"，标志着此义项的独立分化。</p>
<p>但在后世文献中，「婬」字的使用始终没有完全取代「淫」在性道德领域的地位。多数情况下，「淫」仍然是最常用的字形，"淫乱""淫秽"等词均以「淫」为正字，极少写作「婬」。</p>
<h3>现代规范</h3>
<p>在现代汉字规范中，「淫」为正体且使用最广；「霪」作为异体保留在"久雨"这一特定义项上；「婬」则在大多数语境中已被「淫」取代，仅见于某些古籍整理或特定学术语境中。这种"主次分明、分工合理"的字际关系，是现代汉字规范化的一个缩影。</p>`,
    author: '王思齐',
    publishDate: '2025-11-22',
    readTime: '7 分钟',
    tags: ['字际关系', '通假', '异体字', '文字规范'],
    imageSeq: 'yin-yu-yin-yu-yao-06',
  },
  {
    slug: 'shijing-zhong-de-yin',
    title: '《诗经》中的「淫」字用例——兼论先秦诗歌中的节制美学',
    category: 'guji-yongli',
    excerpt: '《诗经》作为中国最早的诗歌总集，其中「淫」字的用例为我们理解先秦时代的词义和观念提供了珍贵的一手材料。本文全面梳理《诗经》中「淫」字的出现语境与语义特征。',
    content: `<p>《诗经》三百零五篇中，「淫」字凡数见。这些用例集中于《国风》和《小雅》，为我们理解「淫」字在先秦诗歌语境中的语义和情感色彩提供了直接的文献依据。</p>
<h3>「淫」字在《诗经》中的分布</h3>
<p>据笔者统计，「淫」字在《诗经》正文中共出现多次，分别见于：</p>
<p>《邶风·雄雉》："瞻彼日月，悠悠我思。道之云远，曷云能来？百尔君子，不知德行。不忮不求，何用不臧？……"此处虽未直接出现「淫」字，但毛传以"淫"释诗中情感之过度，反映了汉儒以"淫"评诗的诠释传统。</p>
<p>《小雅·鼓钟》是一首与"淫"字语义密切相关的诗篇。诗中"鼓钟将将，淮水汤汤，忧心且伤。淑人君子，怀允不忘"表达了一种深沉的忧思，毛传认为这种情感表达"哀而不淫"，恰到好处。</p>
<h3>「淫」与先秦诗歌批评</h3>
<p>「淫」字在先秦诗歌批评中扮演着重要角色。《论语·八佾》中孔子"《关雎》乐而不淫，哀而不伤"的著名论断，奠定了中国古典诗学"中和之美"的基本原则。</p>
<p>孔安国解释"乐而不淫"时说："乐不至淫。"朱熹进一步阐发："淫者，乐之过而失其正者也。"这里的「淫」，已经不是具体的行为描述，而是一个重要的文艺批评概念——指情感表达的过度和失控。</p>
<h3>《诗经》「淫」义的三个层次</h3>
<p>在《诗经》诠释传统中，「淫」字的使用呈现出三个层次：一是字面义，指"久雨"（如"淫雨"）；二是引申义，指"过度"（如"淫乐"）；三是批评义，指情感表达的失当。这三个层次的叠加，使「淫」成为理解先秦诗学观念的关键词。</p>`,
    author: '陈明远',
    publishDate: '2025-07-12',
    readTime: '8 分钟',
    tags: ['诗经', '先秦文学', '孔子', '诗歌批评'],
    imageSeq: 'shijing-yin-07',
  },
  {
    slug: 'zuozhuan-xianqin-yin',
    title: '《左传》与先秦文献中的「淫」——政治话语中的道德评判',
    category: 'guji-yongli',
    excerpt: '《左传》中「淫」字大量出现，且多用于政治和道德评判语境。本文分析《左传》《国语》等先秦史传文献中「淫」字的使用模式，揭示其作为政治道德话语关键词的功能。',
    content: `<p>在先秦史传文献中，「淫」字的使用频率远高于一般想象。《左传》中「淫」字出现数十次，《国语》中也多次使用，且绝大多数出现在政治评判和道德训诫的语境中。这从一个侧面反映了「淫」字在先秦政治话语体系中的重要地位。</p>
<h3>「淫」在《左传》中的使用类型</h3>
<p>《左传》中「淫」字的用法可归纳为以下几类：</p>
<p>第一类：描述自然现象。"天作淫雨，害于粢盛"（庄公十一年），用「淫」字本义"久雨"。</p>
<p>第二类：批评统治者行为失度。"骄奢淫佚，所自邪也"（隐公三年），将「淫」与骄、奢、佚并列，构成一组负面行为描述词。「淫刑以逞，谁则无罪」（僖公二十三年），批评滥用刑罚。</p>
<p>第三类：评价礼乐制度的败坏。"淫乐"在《左传》中指不合礼制的音乐享受，往往作为政治衰败的标志。</p>
<h3>「淫」作为政治批评工具</h3>
<p>值得注意的是，《左传》中对「淫」的使用，往往带有鲜明的政治立场和道德判断。"淫"不仅仅是一个描述性词语，更是史官进行历史评判的工具。某人被描述为"淫"，往往意味着其政治合法性的削弱。</p>
<p>《左传·襄公二十九年》记载吴公子季札观乐，对各国音乐进行评论，其中多次使用与"淫"相关的评判话语。这表明「淫」/「不淫」已经成为先秦礼乐评判的核心维度之一。</p>
<h3>从《左传》到后世史书的延续</h3>
<p>《左传》以「淫」论政论人的传统，被后世纪传体史书全面继承。《史记》《汉书》中「淫」字的使用模式与《左传》高度一致，形成了中国史学中一条独特的"以淫论政"的话语线索。</p>`,
    author: '林之柔',
    publishDate: '2025-08-05',
    readTime: '9 分钟',
    tags: ['左传', '先秦史', '政治话语', '道德评判'],
    imageSeq: 'zuozhuan-yin-08',
  },
  {
    slug: 'shuowenjiezi-xunshi-yin',
    title: '《说文解字》对「淫」的训释——兼论清代说文学的补充与修正',
    category: 'guji-yongli',
    excerpt: '许慎《说文解字》对「淫」字的训释奠定了两千年来汉字学的基础。本文详析许慎原训，并考察段玉裁、朱骏声、王筠等清代说文学家对许说的补充、修正与发挥。',
    content: `<p>许慎《说文解字·水部》对「淫」字的基本训释是："淫，侵淫随理也。从水㸒声。一曰久雨为淫。"这条简短的训释，成为两千年来理解「淫」字的基础，也引发了后世学者持续不断的讨论和补充。</p>
<h3>许慎原训的分析</h3>
<p>许慎给出了两个义项，这在《说文》中并不罕见。"侵淫随理"指的是像水浸渍物体一样顺着纹理逐渐渗透，强调的是"逐渐、渐进"的过程性特征；"久雨为淫"则指向一个具体的自然现象。两个义项的核心都是"浸润、渐进、过度"。</p>
<p>从字形分析看，"从水㸒声"表明许慎将此字视为形声字。但如前所述，「㸒」本身兼有表意功能，因此「淫」实际上是一个形声兼会意字。</p>
<h3>段玉裁的补充</h3>
<p>段玉裁《说文解字注》是清代说文学的巅峰之作。段注对「淫」字的贡献主要体现在：第一，明确了"久雨"为本义、"侵淫"为引申义的观点；第二，详细梳理了「淫」字在经典文献中的用例；第三，辨析了「淫」「霪」「婬」三字的关系。</p>
<p>段注云："按浸淫者，以渐而入也。《上林赋》'浸淫促节'，《羽猎赋》'浸淫蹷部'，皆谓渐入之意。"段氏以《文选》汉赋用例来佐证"浸淫"的"渐进"义，方法严谨。</p>
<h3>朱骏声与王筠的补充</h3>
<p>朱骏声《说文通训定声》从音韵学角度分析了「淫」字所属的韵部和声纽，并系统整理了「淫」字在文献中的假借用法。王筠《说文句读》则注重字形的历时演变，对「淫」字从篆到隶的形体变化有细致的描写。</p>
<h3>现代学者的反思</h3>
<p>现代古文字学兴起后，学者们利用甲骨文、金文等新材料，对《说文》的训释进行了反思和补充。于省吾、裘锡圭等先生的研究表明，《说文》对「淫」字的训释虽然基本正确，但在构形分析上未能充分利用更早的文字材料，这是时代局限所致。</p>`,
    author: '王思齐',
    publishDate: '2025-10-18',
    readTime: '8 分钟',
    tags: ['说文解字', '段玉裁', '说文学', '训诂学'],
    imageSeq: 'shuowen-yin-09',
  },
  {
    slug: 'rujia-lijiao-zhong-de-yin',
    title: '儒家礼教中的「淫」观念——从「非礼勿视」到「乐而不淫」',
    category: 'wenhua-yanjiu',
    excerpt: '在儒家思想体系中，「淫」不仅仅是一个描述性词语，更是一个承载着深刻伦理判断的核心概念。本文考察「淫」在儒家礼教话语中的多重含义及其文化影响。',
    content: `<p>如果说「仁」是儒家思想的光明面，「淫」则是其阴影面——它代表了儒家所要规范和排斥的一切。在中国传统文化中，「淫」承载了极其丰富的伦理内涵和文化意蕴。</p>
<h3>「淫」作为礼的对立面</h3>
<p>在儒家话语体系中，「淫」首先被定义为"礼"的对立面。《论语·颜渊》中著名的"非礼勿视，非礼勿听，非礼勿言，非礼勿动"，虽然没有直接出现「淫」字，但其逻辑内核是以"礼"来制约一切可能滑向"淫"的行为。</p>
<p>《礼记·乐记》明确指出："郑卫之音，乱世之音也，比于慢矣。桑间濮上之音，亡国之音也，其政散，其民流，诬上行私而不可止也。"这种"乱世之音"被儒家定性为"淫声"，是需要被雅正之音所取代的对象。</p>
<h3>孔子的「乐而不淫」</h3>
<p>孔子对「淫」的态度并非简单地否定，而是提出了一种更为精妙的中道原则。《论语·八佾》："《关雎》乐而不淫，哀而不伤。"</p>
<p>孔安国解释："乐不至淫，哀不至伤，言其和也。"朱熹进一步阐发："淫者，乐之过而失其正者也；伤者，哀之过而害于和者也。"</p>
<p>这种"不淫不伤"的中和美学，成为影响中国文艺创作和批评两千年的核心原则。它强调的是情感表达的适度性和节制性，反对任何形式的过度和放纵。</p>
<h3>宋明理学对「淫」的强化</h3>
<p>到了宋明理学时期，「淫」的道德评判意味进一步强化。程颐"饿死事小，失节事大"的极端表述，虽然引起后世争议，但其背后的逻辑正是将「淫」（失节）视为比死亡更严重的道德污点。</p>
<p>朱熹在《四书章句集注》中反复强调"存天理，灭人欲"，其中需要"灭"的"人欲"，在很大程度上就是指各种"淫"（过度）的欲望。这种将「淫」与人的自然欲望紧密关联的思想倾向，对中国社会产生了深远的影响。</p>`,
    author: '林之柔',
    publishDate: '2025-09-08',
    readTime: '10 分钟',
    tags: ['儒家', '礼教', '孔子', '宋明理学', '伦理'],
    imageSeq: 'rujia-yin-10',
  },
  {
    slug: 'le-er-bu-yin-kongzi',
    title: '「乐而不淫」——孔子文艺观中的节制美学及其当代启示',
    category: 'wenhua-yanjiu',
    excerpt: '孔子"乐而不淫，哀而不伤"的论断是中国古典美学的基石性命题。本文深入解读这一命题的哲学内涵、历史影响及其在当代文化语境中的启示意义。',
    content: `<p>"《关雎》乐而不淫，哀而不伤。"孔子的这句话，虽然只有短短十个字，却成为中国古典美学最核心的命题之一，其影响贯穿了两千年中国文艺史。</p>
<h3>命题的语用语境</h3>
<p>这句话出自《论语·八佾》，是孔子对《诗经·关雎》的评价。《关雎》是一首描写君子思念淑女的情诗，既有追求不得的忧思，又有想象中求而得之的欢悦。孔子认为这首诗的情感表达恰到好处——有欢乐但不放纵，有哀伤但不痛苦。</p>
<p>理解这个命题，关键在于理解「淫」的含义。这里的「淫」不是后世的"淫秽"之义，而是"过度、放纵"的意思。朱熹注云："淫者，乐之过而失其正者也。"</p>
<h3>节制美学的哲学基础</h3>
<p>孔子"乐而不淫"思想植根于先秦儒家的中庸哲学。《中庸》云："喜怒哀乐之未发谓之中，发而皆中节谓之和。"情感的适度表达（中节）就是"和"，而过度（淫）则破坏"和"的状态。</p>
<p>这种节制美学不是否定情感，而是主张情感的理性化表达。它承认人的自然情感，但要求将情感控制在合理的范围内。这种"合理"的标准，在孔子那里是社会化的礼乐规范。</p>
<h3>历史影响与当代意义</h3>
<p>"乐而不淫"的节制美学，深刻影响了中国古代的文学创作和批评。从《文心雕龙》的"情深而不诡"，到司空图《二十四诗品》的"含蓄"，再到王国维《人间词话》的"隔与不隔"，都可以看到孔子这一命题的深远回响。</p>
<p>在当代语境中，"乐而不淫"为我们反思消费文化中的过度娱乐化提供了一种古典资源。当社交媒体和短视频平台不断制造情绪过山车式的体验时，孔子倡导的节制美学，或许能帮助我们重新审视"适度"的价值。</p>`,
    author: '陈明远',
    publishDate: '2025-11-30',
    readTime: '9 分钟',
    tags: ['孔子', '文艺观', '节制美学', '中庸', '当代启示'],
    imageSeq: 'le-er-bu-yin-11',
  },
  {
    slug: 'yin-zi-xiandai-hanyu',
    title: '「淫」字在现代汉语中的语义收缩与社会认知变迁',
    category: 'xiandai-yujing',
    excerpt: '从古汉语的多义并存到现代汉语的语义聚焦，「淫」字经历了显著的语义收缩过程。本文通过语料库数据和社会调查，分析这一变化的轨迹及其背后的社会文化原因。',
    content: `<p>进入现代汉语以来，「淫」字的使用呈现出明显的语义收缩趋势。曾经丰富多彩的义项——久雨、过度、放纵、沉溺——在现代日常语言中大多退居幕后，取而代之的是一个高度聚焦的义域：与性道德相关的负面含义。</p>
<h3>语料库数据的证明</h3>
<p>通过对现代汉语语料库的检索分析可以发现，当代汉语中「淫」字的使用主要集中在以下词语中：淫秽（占比最高）、淫乱、奸淫、淫荡、淫威。而"淫雨""淫乐""浸淫"等传统用法在现代文本中出现频率显著降低，且多限于书面语或特定文体。</p>
<p>这一数据表明，「淫」字的「性道德」义项在现代汉语中获得了压倒性的突显度，其他义项则处于边缘化甚至消失的过程中。</p>
<h3>语义收缩的社会文化原因</h3>
<p>这种语义收缩并非偶然的语言变化，而是深刻的社会文化变迁在语言层面的反映：</p>
<p>第一，法律话语的影响。现代法律体系中对"淫秽物品""淫乱行为"的法律界定，使「淫」字在"性道德"义项上的使用获得了制度性强化。</p>
<p>第二，公共道德的聚焦。随着社会对性道德问题的公共关注度提高，「淫」字在这一领域的语义负荷不断加重，挤压了其他义项的使用空间。</p>
<p>第三，语言经济性原则。在语言使用中，当存在更精确的表达方式时（如"连绵雨"代替"淫雨"），原有的多义表达会被替代，导致相关义项萎缩。</p>
<h3>学术语境中的保留</h3>
<p>值得庆幸的是，在学术研究（尤其是古汉语研究、古典文学研究）领域，「淫」字的丰富语义网络仍得到完整的保留和使用。这说明学术话语在一定程度上维系着语言的"文化记忆"，防止了词义的彻底扁平化。</p>`,
    author: '林之柔',
    publishDate: '2026-01-15',
    readTime: '8 分钟',
    tags: ['现代汉语', '语义收缩', '语料库', '社会语言学'],
    imageSeq: 'xiandai-hanyu-12',
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (currentSlug: string, categorySlug: string, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.category === categorySlug && a.slug !== currentSlug)
    .slice(0, count);
};

export const getFeaturedArticles = (count: number = 6): Article[] => {
  const sorted = [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );
  return sorted.slice(0, count);
};